/* DipCoat Ceramic auto-gift — companion to the "FREE DIP COAT" automatic
 * discount (spend $150 → DipCoat Ceramic Single 100% off, active since
 * 2026-03). Shopify's BXGY discount only FREES the item once it is in the
 * cart; it never adds it. This watcher does the adding — and the removing.
 *
 * Behaviour:
 *   · cart becomes eligible — a qualifying product is present, or spend
 *     reaches the threshold when no qualifying list is set → gift added, marked with the
 *     _dyc_auto_gift line property so a customer-added DipCoat is never touched
 *   · cart stops qualifying                   → OUR gift line is removed, or it
 *     would start costing full price the moment the discount stops applying
 *   · after adding, the server's verdict is checked: if the line is not
 *     actually free (edge carts the discount doesn't cover), it is removed
 *     again and not re-offered this session
 *   · customer deletes the gift               → not re-added this session
 *     (fresh offer only after dropping below and re-crossing the threshold)
 *
 * TURNING THE DEAL ON/OFF: Theme settings → DYC Free Gifts (checkbox, product
 * picker, threshold slider — layout/theme.liquid only loads this file while
 * the checkbox is on). The matching automatic discount in admin must agree
 * with BOTH the product and the threshold: the watcher adds, the discount
 * frees. Watcher without discount = the verify step removes the gift again
 * (fail-safe, but the deal silently does nothing). Discount without watcher =
 * free only if the customer thinks to add the product themselves.
 */
(function () {
  "use strict";
  /* Config comes from theme settings (Theme settings → DYC Free Gifts),
     injected by layout/theme.liquid as window.DYCFreeGift. The hardcoded
     fallbacks are the launch deal (DipCoat Ceramic @ $150, 2026-08-24). */
  var CFG = window.DYCFreeGift || {};
  var GIFT_VARIANT = Number(CFG.variantId) || 51665784799596;
  var THRESHOLD_CENTS = Number(CFG.thresholdCents) || 15000;
  /* Gift-with-purchase mode: the gift is earned by having one of these
     products in the cart, not by cart value. Shopify's cart JSON exposes
     product_id but NOT tags or collections, and product_type is useless here
     (149 of the car kits are typed "Permanent Paint", which 10,000+ OEM
     products also carry — matching on it would hand a free bundle to anyone
     buying OEM paint). So the qualifying ids are resolved server-side when the
     deal is switched on and injected by layout/theme.liquid. Empty list =
     fall back to the spend threshold. */
  var QUALIFY = (function () {
    var out = {};
    var list = CFG.qualifyingProductIds;
    if (Object.prototype.toString.call(list) === "[object Array]") {
      for (var i = 0; i < list.length; i++) out[Number(list[i])] = true;
    }
    return out;
  })();
  var QUALIFY_MODE = Object.keys(QUALIFY).length > 0;
  var PROP_KEY = "_dyc_auto_gift";
  /* variant-scoped so swapping the gift product mid-session offers afresh */
  var SS_ADDED = "dyc-gift-added-" + GIFT_VARIANT;
  var SS_DISMISSED = "dyc-gift-dismissed-" + GIFT_VARIANT;
  var busy = false;

  function cartFetch(url, body) {
    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "X-DYC-Gift": "1" },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  /* Same refresh the drawer's own upsell "+ADD" uses: re-fetch the drawer
     section, swap #Cart-Drawer-Details, keep the desktop upsell wing. */
  function refreshCartUI() {
    if (location.pathname === "/cart") { location.reload(); return; }
    var details = document.getElementById("Cart-Drawer-Details");
    var host = details && details.closest("[data-section]");
    var sectionId = host && host.dataset.section;
    if (!sectionId) return;
    fetch("/cart?section_id=" + sectionId + "&t=" + Date.now() + "&_fd=0")
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.getElementById("Cart-Drawer-Details");
        var existing = document.getElementById("Cart-Drawer-Details");
        if (fresh && existing) {
          var wing = existing.querySelector(".cart-upsells");
          existing.innerHTML = fresh.innerHTML;
          if (wing && window.innerWidth > 1024) {
            var freshWing = existing.querySelector(".cart-upsells");
            if (freshWing) freshWing.replaceWith(wing);
          }
        }
        if (window.lucide) lucide.createIcons();
        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: "dyc-free-gift" });
        }
      })
      .catch(function () {});
  }

  function check() {
    if (busy) return;
    busy = true;
    fetch("/cart.js?_fd=0", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftLine = null;
        var eligibleCents = 0;
        var hasQualifying = false;
        (cart.items || []).forEach(function (it) {
          if (it.properties && it.properties[PROP_KEY]) { giftLine = it; return; }
          eligibleCents += it.final_line_price;
          if (QUALIFY_MODE && QUALIFY[Number(it.product_id)]) hasQualifying = true;
        });
        /* Earned either by owning a qualifying product or by spend, never both. */
        var over = (cart.items || []).length > 0 &&
          (QUALIFY_MODE ? hasQualifying : eligibleCents >= THRESHOLD_CENTS);

        if (!over) {
          /* Below the floor — ALWAYS reset the session flags here, not only
             when our gift line is present. An emptied cart (checkout, clear,
             all lines removed) used to leave SS_ADDED behind, and the next
             ≥threshold cart in the same tab was misread as "customer deleted
             the gift" → silently never offered again (bit Justin 2026-08-24).
             No longer eligible means the next time they are is a fresh offer —
             the same applies when the qualifying product is removed. */
          sessionStorage.removeItem(SS_ADDED);
          sessionStorage.removeItem(SS_DISMISSED);
          if (giftLine) {
            /* the discount stops applying down here; pull our line before it costs money */
            return cartFetch("/cart/change.js", { id: giftLine.key, quantity: 0 }).then(refreshCartUI);
          }
          return;
        }

        if (over && !giftLine) {
          if (sessionStorage.getItem(SS_DISMISSED)) return;
          if (sessionStorage.getItem(SS_ADDED)) {
            /* we added it this session and it is gone while still eligible →
               the customer deleted it; do not keep putting it back */
            sessionStorage.setItem(SS_DISMISSED, "1");
            return;
          }
          var props = {}; props[PROP_KEY] = "1";
          return cartFetch("/cart/add.js", { items: [{ id: GIFT_VARIANT, quantity: 1, properties: props }] })
            .then(function () { return fetch("/cart.js?_fd=0", { credentials: "same-origin" }).then(function (r) { return r.json(); }); })
            .then(function (c2) {
              var gl = null;
              (c2.items || []).forEach(function (it) { if (it.properties && it.properties[PROP_KEY]) gl = it; });
              if (gl && gl.final_line_price > 0) {
                /* server says this cart doesn't qualify — undo, don't re-offer */
                sessionStorage.setItem(SS_DISMISSED, "1");
                return cartFetch("/cart/change.js", { id: gl.key, quantity: 0 }).then(refreshCartUI);
              }
              sessionStorage.setItem(SS_ADDED, "1");
              refreshCartUI();
            });
        }
      })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  /* run after any cart mutation (ours carry X-DYC-Gift and are skipped) */
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var init = arguments[1];
    var ours = init && init.headers && (init.headers["X-DYC-Gift"] || (typeof init.headers.get === "function" && init.headers.get("X-DYC-Gift")));
    var p = origFetch.apply(this, arguments);
    if (!ours && /\/cart\/(add|change|update|clear)(\.js)?([?/]|$)/.test(url)) {
      p.then(function () { setTimeout(check, 300); }, function () {});
    }
    return p;
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", check);
  else check();
  window.addEventListener("pageshow", function (e) { if (e.persisted) check(); });
})();
